import { z } from 'zod';

export const guestSchema = z.object({
  firstName: z.string().min(2),
  gender: z.string().optional(),
  lastName: z.string().min(2),
  title: z.string(),
  roomNumber: z.number().optional(),
});

export const optionalGuestSchema = z.object({
  firstName: z.string().optional(),
  gender: z.string().optional(),
  lastName: z.string().optional(),
  title: z.string().optional().nullable(),
});

export const filteredGuestSchema = z.object({
  firstName: z.string(),
  gender: z.string(),
  lastName: z.string(),
  title: z.string(),
});
export type MappedGuest = z.infer<typeof optionalGuestSchema>;
export type FilteredGuest = z.infer<typeof filteredGuestSchema>;

export const GuestFieldFormSchema = z.object({
  rooms: z.array(z.array(guestSchema)),
  notes: z.string().optional(),
});
export type GuestsFormValues = z.infer<typeof GuestFieldFormSchema>;
